import type { MutationResult } from '@apollo/client';
import type { StripeError } from '@stripe/stripe-js';

import type { PurchaseAndActivateMutation } from 'src/generated/graphql';

export type CheckoutFormError =
  | { kind: 'expected'; message: string }
  | { kind: 'unexpected' };

export const getError = (
  stripeError: StripeError | null | undefined,
  purchaseProductResult: MutationResult<PurchaseAndActivateMutation>,
): CheckoutFormError | null => {
  if (purchaseProductResult.error?.networkError) {
    return { kind: 'unexpected' };
  }

  if (stripeError) {
    return {
      kind: 'expected',
      message:
        stripeError.message || 'An error occurred with your payment method.',
    };
  }

  if (purchaseProductResult.error) {
    return { kind: 'expected', message: purchaseProductResult.error.message };
  }

  return null;
};
